export default __webpack_public_path__ + "static/media/drive-icon.7ea7c5f2.svg";